import { render, staticRenderFns } from "./SearchResultList.vue?vue&type=template&id=6bf86300&scoped=true"
import script from "./SearchResultList.vue?vue&type=script&lang=js"
export * from "./SearchResultList.vue?vue&type=script&lang=js"
import style0 from "./SearchResultList.vue?vue&type=style&index=0&id=6bf86300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf86300",
  null
  
)

export default component.exports